import { useState, useEffect } from 'react';
import { useNotificationStore } from '../../notifications/store/useNotificationStore.js';

export function useBookmarks() {
  const { showToast } = useNotificationStore();
  const [bookmarks, setBookmarks] = useState<string[]>(() => {
    if (typeof window !== 'undefined') {
      try {
        const saved = localStorage.getItem('uibn_blog_bookmarks');
        return saved ? JSON.parse(saved) : [];
      } catch (e) {
        return [];
      }
    }
    return [];
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('uibn_blog_bookmarks', JSON.stringify(bookmarks));
    }
  }, [bookmarks]);

  const isBookmarked = (slug: string) => bookmarks.includes(slug);

  const toggleBookmark = (slug: string, title?: string) => {
    if (isBookmarked(slug)) {
      setBookmarks((prev) => prev.filter((s) => s !== slug));
      showToast('Bookmark Dihapus', title ? `"${title}" dihapus dari simpanan` : 'Artikel dihapus dari bookmark', 'info');
    } else {
      setBookmarks((prev) => [...prev, slug]);
      showToast('Bookmark Disimpan', title ? `"${title}" tersimpan di bookmark Anda` : 'Artikel berhasil disimpan ke bookmark', 'success');
    }
  };

  return {
    bookmarks,
    isBookmarked,
    toggleBookmark,
  };
}
